import type { ApiResponse } from "@/types";
import { queryOptions, useQuery } from "@tanstack/react-query";
import type { DockmasterSpan } from "../../../schemas/codegen";
import { api } from "../api/api";
import { QUERY_KEYS } from "./queryKeys";

export type Trace = {
  traceId: string;
  spans: DockmasterSpan[];
};

export type TracesResponse = {
  traces: Trace[];
};

export type TracesQueryOptions = {
  limit?: number;
  windowMinutes?: number;
};

export function getTracesQueryOptions(
  projectId: string,
  options?: TracesQueryOptions,
) {
  return queryOptions({
    queryKey: [
      QUERY_KEYS.TRACES,
      projectId,
      options?.limit ?? null,
      options?.windowMinutes ?? null,
    ],
    queryFn: () => api.getTraces(projectId, options),
  });
}

export function useTraces(
  projectId: string,
  options?: TracesQueryOptions & {
    enabled?: boolean;
    refetchInterval?: number | false;
  },
) {
  return useQuery<ApiResponse<TracesResponse>, Error, TracesResponse>({
    queryKey: [
      QUERY_KEYS.TRACES,
      projectId,
      options?.limit ?? null,
      options?.windowMinutes ?? null,
    ],
    queryFn: () => api.getTraces(projectId, options),
    enabled: options?.enabled ?? !!projectId,
    select: (response) => response.data,
    refetchInterval:
      options?.refetchInterval === undefined ? 5000 : options.refetchInterval,
  });
}
